import CertCard from "./CertCard.js"

import hr from "../assets/curve-hr.svg"
import html_css from "../assets/certs/html_css.jpg"
import javascript from "../assets/certs/javascript.jpg"
import jQuery from "../assets/certs/jQuery.jpg"
import React from "../assets/certs/React.jpg"
import Javascript_hackerRank from "../assets/certs/javascript_intermediate certificate.png"
import Angular from '../assets/certs/Angular.jpg'


export default function Certs(){
    return (
        <div id="certs" className="mt-4 text-white">
            <h1 className="text-2xl font-bold">Certifications</h1>
            <p className="font-light text-gray-400">Here are some of my Certifications</p>
            <div className="grid grid-cols-1 md:grid-cols-3 justify-center mt-4 gap-5">
                <CertCard name="HTML/CSS" img={html_css} issued="cutshort" date="Jul 2022" />
                <CertCard name="Javascript" img={javascript} issued="cutshort" date="Jun 2022" />
                <CertCard name="jQuery" img={jQuery} issued="cutshort" date="Jun 2022" />
                <CertCard name="React" img={React} issued="cutshort" date="Jun 2022" />
                <CertCard name="Javascript" img={Javascript_hackerRank} issued="Hacker Rank" date="Jun 2022" />
                <CertCard name="Angular 2+" img={Angular} issued="cutshort" date="Jun 2022" />
                
            </div>
            <img src={hr} className="w-full mt-8 md:h-2" alt="hr" />
        </div>
    )
}
